import React from 'react';
import { Text } from 'components/typography';
import { useIntl } from 'react-intl';
import { ManageSystemAdminPermissions } from '../ManageSystemAdminPermissions';
import { ManageAdminPermissions } from '../ManageAdminPermissions';
import styles from './styles.module.scss';

export const PortalManagement = () => {
  
  const intl = useIntl();
  
  return (
    <div className={styles.portalManagementContainer}>
      <Text
        size={20}
        fontWeight={700}
      >
        {intl.formatMessage({ id: 'portalManagement' })}
      </Text>
      <ManageSystemAdminPermissions />
      <ManageAdminPermissions />
    </div>
  );
};
